const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

export const hasStartedPeriod = (startDate?: string | null, now: Date = new Date()): boolean => {
    if (!startDate || !dateRegex.test(startDate)) {
        return false;
    }
    const start = new Date(`${startDate}T00:00:00Z`);
    if (Number.isNaN(start.getTime())) {
        return false;
    }
    return start.getTime() < now.getTime();
};

export const isDateInFuture = (date?: string | null, now: Date = new Date()): boolean => {
    if (!date || !dateRegex.test(date)) {
        return false;
    }
    const parsed = new Date(`${date}T00:00:00Z`);
    if (Number.isNaN(parsed.getTime())) {
        return false;
    }
    return parsed.getTime() > now.getTime();
};
